(() => {
  const builder = document.querySelector('[data-ab-bundle]');
  if (!builder) return;

  const cards = [...builder.querySelectorAll('[data-bundle-product]')];
  if (!cards.length) return;

  const productIds = new Set(cards.map((card) => Number(card.dataset.productId)));
  const variants = new Map(cards.map((card) => [card.dataset.variantId, card]));
  const selection = new Map();
  const storageKey = 'ab-cushion-builder-selection';
  const root = builder.dataset.root.endsWith('/') ? builder.dataset.root : `${builder.dataset.root}/`;
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const countNode = builder.querySelector('[data-bundle-count]');
  const unitNode = builder.querySelector('[data-bundle-unit]');
  const totalNode = builder.querySelector('[data-bundle-total]');
  const existingNode = builder.querySelector('[data-bundle-existing]');
  const progressNode = builder.querySelector('[data-bundle-progress]');
  const nextNode = builder.querySelector('[data-bundle-next]');
  const submitButton = builder.querySelector('[data-bundle-submit]');
  const errorNode = builder.querySelector('[data-bundle-error]');
  let cartItems = [];
  let pending = false;
  let lastTier = 0;

  const tier = (count) => count >= 8 ? 4000 : count >= 6 ? 4500 : count >= 4 ? 5000 : count >= 2 ? 6500 : 8000;
  const quantityInCart = (variantId) => cartItems
    .filter((item) => String(item.variant_id) === variantId)
    .reduce((sum, item) => sum + item.quantity, 0);
  const existingCount = () => cartItems
    .filter((item) => productIds.has(Number(item.product_id)) && item.properties?._ab_gift !== 'peaux-300')
    .reduce((sum, item) => sum + item.quantity, 0);
  const selectedCount = () => [...selection.values()].reduce((sum, quantity) => sum + quantity, 0);

  function event(action, extra = {}) {
    window.dispatchEvent(new CustomEvent('ab:bundle', {
      detail: { action, quantity: existingCount() + selectedCount(), ...extra },
    }));
  }

  function storeSelection() {
    try { sessionStorage.setItem(storageKey, JSON.stringify([...selection])); } catch (_) { /* Storage is optional. */ }
  }

  function restoreSelection() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(saved)) return;
      for (const [id, quantity] of saved) {
        const card = variants.get(String(id));
        const max = Number(card?.dataset.max || 0);
        if (card?.dataset.available === 'true' && Number.isInteger(quantity) && quantity > 0) {
          selection.set(String(id), Math.min(quantity, max));
        }
      }
    } catch (_) { /* Ignore stale or blocked storage. */ }
  }

  function nextTierText(count) {
    if (count >= 8) return 'Meilleur tarif atteint : 40 € par pièce.';
    const target = count < 2 ? 2 : count < 4 ? 4 : count < 6 ? 6 : 8;
    const price = target === 2 ? '65 €' : target === 4 ? '50 €' : target === 6 ? '45 €' : '40 €';
    const remaining = target - count;
    return `Ajoutez ${remaining} coussin${remaining > 1 ? 's' : ''} pour passer à ${price} par pièce.`;
  }

  function render() {
    for (const card of cards) {
      const id = card.dataset.variantId;
      const quantity = selection.get(id) || 0;
      const max = Number(card.dataset.max);
      card.classList.toggle('ab-bundle__item--selected', quantity > 0);
      const output = card.querySelector('[data-bundle-quantity]');
      if (!output) continue;
      output.textContent = quantity;
      card.querySelector('[data-bundle-minus]').disabled = pending || quantity === 0;
      card.querySelector('[data-bundle-plus]').disabled = pending || quantity + quantityInCart(id) >= max;
    }

    const selected = selectedCount();
    const existing = existingCount();
    const count = selected + existing;
    const unit = tier(count);
    countNode.textContent = `${count} coussin${count > 1 ? 's' : ''}`;
    unitNode.textContent = money(unit);
    totalNode.textContent = money(count * unit);
    existingNode.hidden = existing === 0;
    existingNode.textContent = `${existing} coussin${existing > 1 ? 's' : ''} déjà dans le panier`;
    progressNode.value = Math.min(count, 8);
    nextNode.textContent = count === 0 ? 'Sélectionnez les modèles à associer.' : nextTierText(count);
    submitButton.disabled = pending || selected === 0;
    submitButton.textContent = pending ? 'Ajout en cours…' : selected === 0 ? 'Ajouter l’ensemble au panier' : `Ajouter ${selected} coussin${selected > 1 ? 's' : ''} au panier`;

    const currentTier = count >= 8 ? 8 : count >= 6 ? 6 : count >= 4 ? 4 : count >= 2 ? 2 : 1;
    if (lastTier && currentTier > lastTier) event('tier_reached', { tier: currentTier });
    lastTier = currentTier;
  }

  async function refreshCart() {
    const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Le panier est momentanément indisponible.');
    const cart = await response.json();
    cartItems = cart.items || [];
    for (const card of cards) {
      const id = card.dataset.variantId;
      const quantity = selection.get(id) || 0;
      const allowed = Math.max(0, Number(card.dataset.max) - quantityInCart(id));
      if (quantity > allowed) selection.set(id, allowed);
    }
    storeSelection();
    render();
  }

  builder.addEventListener('click', (clickEvent) => {
    const button = clickEvent.target.closest('[data-bundle-plus], [data-bundle-minus]');
    if (!button || pending) return;
    const card = button.closest('[data-bundle-product]');
    const id = card.dataset.variantId;
    const current = selection.get(id) || 0;
    const increment = button.hasAttribute('data-bundle-plus') ? 1 : -1;
    const max = Math.max(0, Number(card.dataset.max) - quantityInCart(id));
    const next = Math.max(0, Math.min(max, current + increment));
    if (next === current) return;
    if (next) selection.set(id, next); else selection.delete(id);
    errorNode.hidden = true;
    storeSelection();
    render();
    event(increment > 0 ? 'add_cushion' : 'remove_cushion', { variantId: id });
  });

  submitButton.addEventListener('click', async () => {
    if (pending || selectedCount() === 0) return;
    pending = true;
    errorNode.hidden = true;
    render();
    const items = [...selection].filter(([, quantity]) => quantity > 0).map(([id, quantity]) => ({ id: Number(id), quantity }));
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Impossible d’ajouter cette sélection.');
      event('add_bundle_to_cart', { items: items.length });
      selection.clear();
      storeSelection();
      await refreshCart();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-bundle', cartData: result });
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
        drawer.renderContents(result);
      } else {
        window.location.assign(`${root}cart`);
      }
    } catch (error) {
      errorNode.textContent = error.message || 'Impossible d’ajouter cette sélection.';
      errorNode.hidden = false;
      try { await refreshCart(); } catch (_) { /* Keep the current selection visible. */ }
    } finally {
      pending = false;
      render();
    }
  });

  restoreSelection();
  render();
  refreshCart().catch(() => {
    errorNode.textContent = 'Le panier est momentanément indisponible. Réessayez dans un instant.';
    errorNode.hidden = false;
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (update) => {
      if (update.source !== 'ab-bundle') refreshCart().catch(() => {});
    });
  }
  const footer = document.querySelector('footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      builder.querySelector('[data-bundle-summary]').classList.toggle('ab-bundle__summary--hidden', entry.isIntersecting);
    }).observe(footer);
  }
  window.addEventListener('pageshow', (pageEvent) => { if (pageEvent.persisted) refreshCart().catch(() => {}); });
  event('builder_open');
})();
